import React from "react";
import "./breadcrumb-scheduling.scss";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import { withPrefix } from "gatsby";

const BreadcrumbScheduling = (props: BreadcrumbInterface) => {
  const { content } = props;
  const { isBrowser } = useBrowserMode();

  const breadcrumbs = (crumbs: string) =>
    crumbs.split("/").map((value, index) => {
      return (
        <li key={index} itemProp="url" className={`crumb url-${index}`}>
          <a
            title={value}
            href={withPrefix("agenda-red-de-amor/")}
            rel="nofollow noreferrer"
          >
            <span itemProp="title"> {value} </span>
          </a>
        </li>
      );
    });

  return (
    <nav itemType="https://schema.org/Breadcrumb" className="miga-de-pan">
      <ul className="a-breadcrumb-scheduling">
        {isBrowser && breadcrumbs(content)}
      </ul>
    </nav>
  );
};

interface BreadcrumbInterface {
  content: any;
}

export default BreadcrumbScheduling;
